import LockIcon from '@mui/icons-material/Lock';

const PLAN_LABELS = { trial: 'Trial', basic: 'נֵר', pro: 'מְנוֹרָה', community: 'מָאוֹר' };

/**
 * LockedWidgetPlaceholder - shown on the display when a widget requires a higher plan.
 * Replaces the widget content while preserving the grid slot.
 */
const LockedWidgetPlaceholder = ({ widgetName, requiredPlan }) => (
    <div style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, rgba(30,58,95,0.07) 0%, rgba(21,42,71,0.04) 100%)',
        border: '1.5px solid rgba(30,58,95,0.18)',
        borderRadius: 8,
        gap: 10,
        padding: 16,
        boxSizing: 'border-box',
        direction: 'rtl',
        backdropFilter: 'blur(2px)',
    }}>
        <div style={{
            width: 44,
            height: 44,
            borderRadius: 12,
            background: 'rgba(30,58,95,0.1)',
            border: '1px solid rgba(30,58,95,0.18)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <LockIcon style={{ fontSize: 22, color: '#1e3a5f', opacity: 0.5 }} />
        </div>
        {widgetName && (
            <p style={{ margin: 0, fontWeight: 700, fontSize: '0.95rem', color: '#1e3a5f', textAlign: 'center', opacity: 0.75, letterSpacing: '-0.01em' }}>
                {widgetName}
            </p>
        )}
        <p style={{ margin: 0, fontSize: '0.75rem', color: '#5a6978', textAlign: 'center', lineHeight: 1.6 }}>
            {requiredPlan === 'blocked' ? 'רכיב זה חסום' : (
                <>זמין במסלול<br /><strong style={{ color: '#9a7209' }}>{PLAN_LABELS[requiredPlan] || requiredPlan}</strong></>
            )}
        </p>
    </div>
);

export default LockedWidgetPlaceholder;
